export default __webpack_public_path__ + "media/images/celeste_unlock-e8d1069ff1f078fe74152ea2f4130d2c.png";